import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=52588b35&scoped=true&"
import script from "./newsList.vue?vue&type=script&lang=js&"
export * from "./newsList.vue?vue&type=script&lang=js&"
import style0 from "./newsList.vue?vue&type=style&index=0&id=52588b35&prod&lang=css&"
import style1 from "./newsList.vue?vue&type=style&index=1&id=52588b35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52588b35",
  null
  
)

export default component.exports